// paladin.core.browse
const {
  name,
  version
} = require('../package.json')

const install = (Vue, options) => {
  if (!Vue._installedPlugins.find((plugin) => plugin.Store)) {
    throw new Error('PaladinCoreBrowse plugin must be installed after the Vuex plugin.')
  }

  if (PaladinCoreBrowse.installed) {
    return
  }
  PaladinCoreBrowse.installed = true

  let _timestamp = null
  if (process.env.NODE_ENV === 'development') {
    _timestamp = new Date()
    console.log(
      `%c${name}` + `%c#${version}: ` + '%cInstalling Module...',
      'color: #2ecc71',
      'color: #3498db',
      ''
    )
  }

  const {
    store
  } = options

  if (!store) {
    throw new Error('Please provide a vuex store.')
  }

  // initialize global moduleRoutes if it doesn't exist
  Vue.$moduleRoutes = Vue.$moduleRoutes ? Vue.$moduleRoutes : []

  var routes = [{
    path: 'browse',
    name: 'browse',
    component: () => import( /* webpackChunkName: "browse" */ './router/views/browse'),
    props: ( /* route */ ) => ({
      user: store.state.user || {}
    }),
    meta: {
      authRequired: true,
      menuSettings: {
        visible: true,
        order: 2,
        pluginArea: 'navigation.main', // navigation (navigation.notifications | navigation.events) | global-menu | user-menu | footer-menu
        showChildren: false,
        icon: 'sitemap',
        text: 'Browse',
        target: '/browse', // can be URL or route
      },
    },
  }, ]

  Vue.$moduleRoutes.push(...routes)

  // get routes

  // export module routes

  // export module vuex stores

  // not sure about the below yet
  // define components (optional)
  // define global methods (optional)
  // define instance methods (optional)
  // define mixins, directives, filters, etc. (optional)

  // creates a instance method that can be used inside of a Vue component
  // Vue.prototype.$parseContent = function(content) {
  //   return helpers.parseContent(content, shortcodes)

  if (process.env.NODE_ENV === 'development') {
    let _executionTime = new Date() - _timestamp
    // console.log(`${name}#${version}: Installed in ${_executionTime}ms`)
    let _msColor = _executionTime < 100 ? '#2ecc71' : '#f1c40f'
    if (_executionTime >= 200) _msColor = '#e74c3c'
    console.log(
      `%c${name}` + `%c#${version}: ` + '%cInstalled in ' + `%c${_executionTime}ms`,
      'color: #2ecc71',
      'color: #3498db',
      '',
      `color: ${_msColor}`
    )
  }
}

const PaladinCoreBrowse = {
  install,
  version,
}

export {
  PaladinCoreBrowse
}

// #Automatic Installation
// For people who use your plugin outside of a module system,
// it is often expected that if your plugin is included after
// the Vue script tag, that it will automatically install itself
// without the need to call Vue.use(). You can implement this by
// appending these lines to the end of my-vue-plugin.js:
// if (typeof window !== 'undefined' && window.Vue) {
//   window.Vue.use(PaladinCoreBrowse)
// }
